<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div :class="['IM_3_' + this.id]">
    <BackGround ref="background" tutorial />
    <Interface class="interface mx-auto" ref="interface" tutorial />

    <div v-show="step == 1" class="sreen">
      <div class="back"></div>
      <div class="leon">
        <img src="https://cdn.exploreve.fr/content/personnages/leon.svg" />
      </div>
      <div class="bulle" style="top: 20vh; left: 42vw;">
        <p>Avant de sauter dans ton ballon, laisse-moi tout de même t’expliquer comment il fonctionne.</p>

        <p>
          Ton ballon se déplace grâce aux vents : il avance à la même vitesse et dans la même direction que le vent. Il
          n'y a pas de volant sur un ballon, pas de moyen de le diriger à droite ou à gauche. En revanche, tu vas
          pouvoir le faire monter ou descendre ! Je vais t'apprendre à piloter !
        </p>
      </div>
      <div class="next-button" style="bottom: 5vh; right: 5vw;" v-on:click="step += 1">
        Poursuivre les explications
      </div>
    </div>
    <div v-show="step == 2" class="sreen">
      <div class="back"></div>
      <div class="cadre" style="top: 20vh; left: 42vw;">
        <p style="font-weight: bold;">Se déplacer</p>
        <p>Avec ces deux boutons, tu peux faire monter ou descendre ton ballon.</p>
        <p>
          - Pour monter, chauffe l'air du ballon en activant le brûleur. L'air chaud étant plus léger que l'air froid,
          si l'air à l'intérieur du ballon est plus chaud que celui à l'extérieur le ballon s’élève.
        </p>
        <p>
          - Pour descendre, appuie sur la soupape. Le ballon perd de l’air chaud, se refroidit et commence à descendre.
        </p>
      </div>
      <div class="highlight1"></div>
      <div class="next-button" style="bottom: 5vh; right: 5vw;" v-on:click="step += 1">
        Suivant
      </div>
    </div>
    <div v-show="step == 3" class="sreen">
      <div class="back"></div>
      <div class="cadre" style="top: 20vh; left: 42vw;">
        <p style="font-weight: bold;">Se repérer</p>
        <p>
          Ton objectif est d’atteindre ce point marron, mais pour ça il faut suivre le trajet de ta carte avec attention
          ! Comment faire ? C’est simple, tu dois faire monter ou descendre ton ballon pour te positionner dans le
          courant de vent qui t'arrange.
        </p>
        <p>
          Il y a le vent qui souffle vers le Nord, un autre vers le Sud, un troisème vers l’Est et un dernier vers
          l’Ouest. Si ta carte t’indique par exemple d’aller au Nord, il faut donc que tu te positionnes dans le vent du
          Nord !
        </p>
      </div>
      <div class="highlight2"></div>
      <div class="next-button" style="bottom: 5vh; right: 5vw;" v-on:click="step += 1">
        Suivant
      </div>
    </div>
    <div v-show="step == 4" class="sreen">
      <div class="back"></div>
      <div class="cadre" style="top: 20vh; left: 42vw;">
        <p style="font-weight: bold;">Pour finir</p>
        <p>Un dernier conseil… Suis scrupuleusement le chemin sur ta carte si tu veux arriver à bon port !</p>

        <p>
          Maintenant, place à la pratique. Tu vas pouvoir utiliser le ballon-songe en cliquant sur “Démarrer”&nbsp;! On
          se retrouve à la fin du parcours !
        </p>
      </div>
      <NextBtn url="/immersion03/3" text="Démarrer" class="next-button" style="bottom: 5vh; right: 5vw;" />
    </div>
  </div>
</template>

<script>
import BackGround from "@/components/immersion03/jeu_ballon/Background";
import Interface from "@/components/immersion03/jeu_ballon/Interface";
import NextBtn from "@/components/NextButton";
export default {
  name: "IM_3_1",
  data: function () {
    return {
      id: 2,
      step: 1
    };
  },
  mounted() {
    this.$refs.background.pauseAnimations();
    this.$emit("audio", { action: "play", id: "music03" });
  },
  methods: {},
  components: { BackGround, Interface, NextBtn }
};
</script>

<style scoped lang="scss">
.router-button {
  position: absolute;
  z-index: 202;
  bottom: 5vh;
  right: 5vw;
}
.highlight2 {
  border: 5px solid #fbead3;
  border-radius: 20vw / 35vh;
  width: 20vw;
  height: 35vh;
  position: absolute;
  bottom: 1vh;
  left: 44vw;
  z-index: 201;
}
.highlight1 {
  border: 5px solid #fbead3;
  border-radius: 20vw / 20vh;
  width: 20vw;
  height: 20vh;
  position: absolute;
  top: 75vh;
  left: 25vw;
  z-index: 210;
}
.next-button {
  position: absolute;
  font-family: "faune";
  font-size: 24px;
  padding: 5px 50px;
  background-color: #5e2a57;
  color: white !important;
  text-decoration: none !important;
  border-radius: 5px;
  cursor: pointer;
  z-index: 201;
}

.cadre {
  position: absolute;
  top: 5vh;
  margin: 10px;
  background-color: white;
  max-width: 60vh;
  height: auto;
  border-radius: 20px;
  text-align: left;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  z-index: 201;
}

.bulle {
  position: absolute;
  top: 5vh;
  margin: 10px;
  background-color: white;
  max-width: 60vh;
  height: auto;
  border-radius: 20px;
  text-align: left;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  z-index: 201;
}

.bulle::after {
  content: "";
  position: absolute;
  left: -40px;
  top: 30%;
  width: 0;
  height: 0;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;

  border-right: 40px solid white;
}

.leon {
  img {
    height: 60vh;
  }
  position: absolute;
  top: 25vh;
  left: 20vw;
  z-index: 201;
}

.back {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.53);
  z-index: 100;
}

.interface {
  position: absolute;
  bottom: 0;
}
</style>
